(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-animation-banner"] && !Shopify.designMode) return;
  try {
    
class YGAnimationBanner extends YGUtils {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlides();
    this.initIntersectionObserver();
  }

  disconnectedCallback() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  initIntersectionObserver() {
    const overlay = this.querySelector('.yg-animation-banner-overlay');
    const wrapper = this.querySelector('.yg-animation-banner-wrapper');

    if (!overlay) return;

    // 检查屏幕宽度，只有在大于 700px 时才执行
    const checkAndInit = () => {
      const windowWidth = window.innerWidth;

      // 如果屏幕宽度 <= 700px，移除监听器并保持初始状态
      if (windowWidth <= 700) {
        if (this.scrollHandler) {
          window.removeEventListener('scroll', this.scrollHandler);
          this.scrollHandler = null;
        }
        // 保持初始状态
        overlay.style.transform = 'scale(1)';
        overlay.style.opacity = '1';
        this.classList.remove('animate');
        if (wrapper) {
          wrapper.classList.remove('active');
        }
        return false;
      }

      // 如果屏幕宽度 > 700px，设置监听器
      if (!this.scrollHandler) {
        // 监听滚动事件，基于 sticky 容器的滚动进度
        let ticking = false;
        this.scrollHandler = () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              const rect = this.getBoundingClientRect();
              const windowHeight = window.innerHeight;
              const containerHeight = rect.height;

              // 计算 sticky 生效的滚动进度
              // 当容器顶部到达视口顶部时 (rect.top <= 0)，sticky 开始生效，progress = 0
              // 当容器底部到达视口顶部时 (rect.bottom <= windowHeight)，sticky 结束，progress = 1

              let progress = 0;

              // 如果容器顶部还在视口下方，sticky 还没生效，progress = 0
              if (rect.top > 0) {
                progress = 0;
              }
              // 如果容器顶部已经滚动过视口顶部，sticky 正在生效
              else if (rect.top <= 0 && rect.bottom > windowHeight) {
                // 计算滚动进度：从容器顶部到达视口顶部到容器底部到达视口顶部
                const scrollableDistance = containerHeight - windowHeight;
                const scrolledDistance = Math.abs(rect.top);
                progress = Math.min(1, scrolledDistance / scrollableDistance);
              }
              // 如果容器底部已经滚动过视口顶部，sticky 结束，progress = 1
              else {
                progress = 1;
              }

              // 只有当 sticky 生效时（progress > 0）才开始动画
              if (progress > 0) {
                // 根据进度计算 scale
                // scale: 1 -> 6，确保放大后完全超出可视区域
                const scale = 1 + (progress * 5);

                // opacity: 在 progress > 0.7 时才开始从 1 变到 0
                // 前 70% 保持完全不透明，后 30% 逐渐变透明
                let opacity = 1;
                if (progress > 0.7) {
                  // progress 从 0.7 到 1，opacity 从 1 到 0
                  opacity = 1 - ((progress - 0.7) / 0.3);
                }

                overlay.style.transform = `scale(${scale})`;
                overlay.style.opacity = opacity;

                // 当进度达到一定程度时显示内容
                if (progress > 0.3) {
                  this.classList.add('animate');
                  if (wrapper) {
                    wrapper.classList.add('active');
                  }
                }
              } else {
                // sticky 还没生效，保持初始状态
                overlay.style.transform = 'scale(1)';
                overlay.style.opacity = '1';
                this.classList.remove('animate');
                if (wrapper) {
                  wrapper.classList.remove('active');
                }
              }

              ticking = false;
            });
            ticking = true;
          }
        };

        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        // 初始检查
        this.scrollHandler();
      }

      return true;
    };

    // 初始检查
    checkAndInit();

    // 监听窗口大小变化，实时检测屏幕宽度
    let resizeTimeout;
    this.resizeHandler = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        checkAndInit();
      }, 100);
    };
    window.addEventListener('resize', this.resizeHandler);
  }

  initSlides() {
    this.swiperInstance = new Swiper(this.querySelector('.swiper'), {
      breakpoints: {
        100: {
          spaceBetween: 12,
          slidesPerView: 1.1,
        },
        700: {
          spaceBetween: 12,
          slidesPerView: 4,
        },
      }
    });
  }
}

if (!window.customElements.get('yg-animation-banner')) {
  window.customElements.define('yg-animation-banner', YGAnimationBanner);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-slide"] && !Shopify.designMode) return;
  try {
    
  class YGImageSlide extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      // 清理 Swiper 实例（如果存在）
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      const swiperElement = this.querySelector('.swiper');
      if (!swiperElement) return;

      this.swiperInstance = new Swiper(swiperElement, {
        navigation: {
          nextEl: this.closest('.shopify-section').querySelector('.swiper-button-next'),
          prevEl: this.closest('.shopify-section').querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          100: {
            spaceBetween: 12,
            slidesPerView: 1.2,
          },
          700: {
            spaceBetween: 12,
            slidesPerView: 1.5,
          },
        },
        on: {
          init: e => {
            if (e.passedParams.loop && e.slides.length < 5) {
              e.slides.forEach(slide => {
                const clonedElement = slide.cloneNode(true);
                e.slidesEl.appendChild(clonedElement);
              })
            }
          }
        }
      });
    }
  }

  if (!window.customElements.get('yg-image-slide')) {
    window.customElements.define('yg-image-slide', YGImageSlide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-reviews"] && !Shopify.designMode) return;
  try {
    
class YGMediaReviews extends YGUtils {
  constructor() {
    super();
  }

  connectedCallback() {
    this.prevButton = this.querySelector('.button-prev');
    this.nextButton = this.querySelector('.button-next');
    this.mainContainer = this.querySelector('.yg-media-reviews-container');
    this.thumbsContainer = this.querySelector('.yg-media-reviews-thumbs');
    this.reviewItems = Array.from(this.mainContainer?.querySelectorAll('.yg-media-reviews-box') ?? []);
    this.reviewsCount = this.reviewItems.length;
    this.currentIndex = 0;

    this.initSlider();
    this.initTouchEvents(); // ✅ 新增：移动端滑动控制
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
    this.removeTouchEvents();
  }

  initSlider() {
    this.swiperInstance = new Swiper(this.thumbsContainer, {
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      navigation: {
        nextEl: this.closest('.shopify-section')?.querySelector('.yg-button-next'),
        prevEl: this.closest('.shopify-section')?.querySelector('.yg-button-prev'),
      },
      breakpoints: {
        100: {
          spaceBetween: 12,
          slidesPerView: 1,
        },
        700: {
          spaceBetween: 16,
          slidesPerView: 'auto',
        },
      },
      on: {
        init: (swiper) => {
          if (swiper.passedParams.loop && swiper.slides.length < 6 && !swiper._ygCloned) {
            swiper._ygCloned = true;
            const originalSlides = Array.from(swiper.slides);
            const cloneCount = Math.ceil(6 / originalSlides.length);
            for (let i = 0; i < cloneCount; i++) {
              originalSlides.forEach((slide) => {
                const clonedElement = slide.cloneNode(true);
                swiper.slidesEl.appendChild(clonedElement);
              });
            }
            swiper.update();
          }
          this.updateActiveReview(swiper.realIndex);
        },
        slideChange: (swiper) => {
          this.updateActiveReview(swiper.realIndex);
        },
        click: (swiper) => {
          this.updateActiveReview(swiper.realIndex);
        },
      },
    });
  }

  updateActiveReview(index) {
    if (!this.reviewItems.length) return;
    const len = this.reviewItems.length;
    const realIdx = ((index % len) + len) % len;
    this.reviewItems.forEach((item, i) => {
      item.classList.toggle('active', i === realIdx);
    });
    this.currentIndex = realIdx;
  }

  // ✅ 触摸滑动逻辑
  initTouchEvents() {
    if (window.innerWidth >= 768) return; // 仅移动端启用

    let startX = 0;
    let endX = 0;
    const threshold = 40; // 滑动最小距离

    this._touchStart = (e) => {
      startX = e.touches[0].clientX;
    };

    this._touchMove = (e) => {
      endX = e.touches[0].clientX;
    };

    this._touchEnd = () => {
      const delta = endX - startX;
      if (Math.abs(delta) > threshold) {
        if (delta < 0) {
          this.swiperInstance.slideNext(); // 向左滑
        } else {
          this.swiperInstance.slidePrev(); // 向右滑
        }
      }
      startX = 0;
      endX = 0;
    };

    this.mainContainer.addEventListener('touchstart', this._touchStart, { passive: true });
    this.mainContainer.addEventListener('touchmove', this._touchMove, { passive: true });
    this.mainContainer.addEventListener('touchend', this._touchEnd);
  }

  removeTouchEvents() {
    this.mainContainer?.removeEventListener('touchstart', this._touchStart);
    this.mainContainer?.removeEventListener('touchmove', this._touchMove);
    this.mainContainer?.removeEventListener('touchend', this._touchEnd);
  }
}

if (!window.customElements.get('yg-media-reviews')) {
  window.customElements.define('yg-media-reviews', YGMediaReviews);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-image-with-text"] && !Shopify.designMode) return;
  try {
    
  class YGTest extends YGUtils {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      // 这里放置自定义逻辑
      this.test({
        text: '123',
      });
    }
  }
  if (!window.customElements.get('yg-test')) {
    window.customElements.define('yg-test', YGTest);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-info-box"] && !Shopify.designMode) return;
  try {
    
  class YGTest extends YGUtils {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      // 这里放置自定义逻辑
      this.test({
        text: '123',
      });
    }
  }
  if (!window.customElements.get('yg-test')) {
    window.customElements.define('yg-test', YGTest);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-slide"] && !Shopify.designMode) return;
  try {
    
  class YGProductSlides extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      // 清理 Swiper 实例（如果存在）
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      const swiperElement = this.querySelector('.swiper');
      if (!swiperElement) return;

      this.swiperInstance = new Swiper(swiperElement, {
        loop: true,
        navigation: {
          nextEl: this.closest('.shopify-section').querySelector('.yg-button-next'),
          prevEl: this.closest('.shopify-section').querySelector('.yg-button-prev'),
        },
        pagination: {
          el: this.closest('.shopify-section').querySelector('.yg-product-slide-pagination'),
          clickable: true,
        },
        spaceBetween: 12,
        slidesPerView: 1,
      });
    }
  }

  if (!window.customElements.get('yg-product-slide')) {
    window.customElements.define('yg-product-slide', YGProductSlides);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tab-video"] && !Shopify.designMode) return;
  try {
    
class YGTabVideo extends YGUtils {
  constructor() {
    super();
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  connectedCallback() {
    this.tabsContainer = this.querySelector('.yg-tab-video-tabs');
    this.tabButtons = Array.from(this.querySelectorAll('.yg-tab-video-tab'));
    this.videoItems = Array.from(this.querySelectorAll('.yg-tab-video-item'));
    this.activeIndex = this.tabButtons.findIndex(button =>
      button.classList.contains('is-active') || button.classList.contains('active'),
    );

    if (this.activeIndex < 0) {
      this.activeIndex = 0;
    }

    this.tabButtons.forEach(button => {
      button.addEventListener('click', this.handleTabClick);
    });

    this.updateActiveTab(this.activeIndex);
  }

  disconnectedCallback() {
    if (this.tabButtons) {
      this.tabButtons.forEach(button => {
        button.removeEventListener('click', this.handleTabClick);
      });
    }
  }

  handleTabClick(event) {
    const index = Number(event.currentTarget.dataset.slide);
    if (Number.isInteger(index)) {
      this.updateActiveTab(index);
    }
  }

  updateActiveTab(index) {
    if (!this.tabButtons || !this.videoItems || index < 0 || index >= this.videoItems.length) return;

    this.activeIndex = index;

    this.tabButtons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === index;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-selected', String(isActive));
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.videoItems.forEach((item, itemIndex) => {
      const isActive = itemIndex === index;
      item.classList.toggle('active', isActive);
    });

    this.scrollTabIntoView(index);
  }

  scrollTabIntoView(index) {
    if (!this.tabsContainer || !window.matchMedia('(max-width: 699px)').matches) return;

    const activeButton = this.tabButtons[index];
    if (!activeButton) return;

    const containerWidth = this.tabsContainer.clientWidth;
    const maxScroll = this.tabsContainer.scrollWidth - containerWidth;

    if (maxScroll <= 0) return;

    const buttonCenter = activeButton.offsetLeft + activeButton.offsetWidth / 2;
    const targetScrollLeft = buttonCenter - containerWidth / 2;

    this.tabsContainer.scrollTo({
      left: Math.min(Math.max(targetScrollLeft, 0), maxScroll),
      behavior: 'smooth',
    });
  }
}

if (!window.customElements.get('yg-tab-video')) {
  window.customElements.define('yg-tab-video', YGTabVideo);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-template-1"] && !Shopify.designMode) return;
  try {
    
  class YGTest extends YGUtils {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      // 这里放置自定义逻辑
      this.test({
        text: '123',
      });
    }
  }
  if (!window.customElements.get('yg-test')) {
    window.customElements.define('yg-test', YGTest);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-template"] && !Shopify.designMode) return;
  try {
    
  class YGTest extends YGUtils {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      // 这里放置自定义逻辑
      this.test({
        text: '123',
      });
    }
  }
  if (!window.customElements.get('yg-test')) {
    window.customElements.define('yg-test', YGTest);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-popup"] && !Shopify.designMode) return;
  try {
    
  class YGVideoPopup extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      // 清理 Swiper 实例（如果存在）
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      this.swiperInstance = new Swiper(this, {
        // navigation: {
        //   nextEl: this.closest('.shopify-section').querySelector('.yg-swiper-button-next'),
        //   prevEl: this.closest('.shopify-section').querySelector('.yg-swiper-button-prev'),
        // },
        breakpoints: {
          100: {
            spaceBetween: 12,
            slidesPerView: 2.3,
          },
          700: {
            spaceBetween: 12,
            slidesPerView: 4,
          },
          1360: {
            spaceBetween: 12,
            slidesPerView: 6,
          },
        },
        on: {
          init: e => {
            if (e.passedParams.loop && e.slides.length < 5) {
              e.slides.forEach(slide => {
                const clonedElement = slide.cloneNode(true);
                e.slidesEl.appendChild(clonedElement);
              })
            }
          }
        }
      });
    }
  }

  if (!window.customElements.get('yg-video-popup')) {
    window.customElements.define('yg-video-popup', YGVideoPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
